<template>
    <div class="layer" style-width="large">
        <div class="inner">
            <div class="mod">
                <table class="table-data">
                    <colgroup>
                        <col style="width: 300px">
                    </colgroup>
                    <thead style="background-color: white;">
                    <tr style="text-align: center" >
                        <th></th>
                        <th style="text-align: center; padding-top: 10px"><a href="/products/websearch">ReportAll</a><br><p style="font-size:x-small">Advanced Data Query</p></th>
                        <th style="text-align: center; padding-top: 10px"><a href="/product/parlay">PARLAY 2.0</a><br><p style="font-size: x-small">Google Earth Integration</p></th>
                        <th style="text-align: center; padding-top: 10px"><a href="/store">Downloads</a><sup><a href="#7">(7)</a></sup><br><p style="font-size: x-small">Vector File Download</p></th>
                        <th style="text-align: center; padding-top: 10px"><a href="/product/api">API</a><br><p style="font-size: x-small">System-to-System Integration</p></th>
                        <th style="text-align: center; padding-top: 10px"><a href="/product/feature-service">Feature Service</a><br></th>
                        <th style="text-align: center; padding-top: 10px"><a href="/product/landglide">LandGlide</a><br><p style="font-size: x-small">iOS, Android, and Web</p></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style="text-align: center">
                        <td style="text-align: left">Search by Address</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Search by Owner</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Search by Parcel Number</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Search by Latitude and Longitude</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Advanced / Multi-Query Search</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Shapefile Polygon Query Submission</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Query by User Defined Map Area</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Display Parcel Boundaries</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Display Data Attributes<sup><a href="#1">(1)</a></sup></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Click On Property in Map View for Data</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Download Parcel Boundary and Attributes<sup><a href="#2">(2)</a></sup></td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;<sup><a href="#3">(3)</a></sup></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Parcel Dimensions</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                    </tr>

                    <tr style="text-align: center">
                        <td style="text-align: left">Linear/Area Measurement</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;<sup><a href="#7">(7)</a></sup></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Attribute Data<sup><a href="#1">(1)</a></sup></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Display Structure Outline<sup><a href="#1">(1)</a></sup></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td>&#10004;<sup><a href="#4">(4)</a></sup></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Flood Maps</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Export Boundaries as KML</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Google Earth Integration</td>
                        <td></td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#5">(5)</a></sup></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Bing Street and Aerial Map Display</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;<sup><a href="#5">(5)</a></sup></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Google Street and Aerial Map Display</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;<sup><a href="#5">(5)</a></sup></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">County Link<sup><a href="#1">(1)</a></sup></td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">System-to-System Integration</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Mobile App</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Laptop / Desktop / Browser Application</td>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr style="text-align: center">
                        <td style="text-align: left">Esri Application Integration </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                        <td></td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="6">
                            <a class="footnote" id="1"><p style="font-size:smaller">1: As available</p></a>
                            <a class="footnote" id="2"><p style="font-size:smaller">2: Additional charges may be incurred for data download</p></a>
                            <a class="footnote" id="3"><p style="font-size:smaller">3: Dependent on capabilities of the third-party software you use to access the data</p></a>
                            <a class="footnote" id="4"><p style="font-size:smaller">4: Dependent on the capabilities of the application you integrate the data into</p></a>
                            <a class="footnote" id="5"><p style="font-size:smaller">5: Use KML format download (no additional cost) to overlay in these mapping products</p></a>
                            <a class="footnote" id="6"><p style="font-size:smaller">6: Data downloads available in Excel, KML, CSV and Shapefile formats</p></a>
                            <a class="footnote" id="7"><p style="font-size: smaller">7: Feature not available on all platforms</p></a>
                            <p style="font-size: smaller">All data should be considered reliable but is not guaranteed.</p>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ComparisonTable",

        mounted() {
            let $table = $('.table-data');
            $table.floatThead({
                responsiveContainer: function($table) {
                    return $table.closest('.main');
                },
                position: 'absolute'
            });
        }
    }
</script>

<style scoped>
    a.footnote {
        color: inherit;
        font-weight: 400;
    }
    sup {
        vertical-align: super;
        font-size: x-small;
    }
</style>
